class Company {
  constructor() {
    this.company = ''
    this.vatid = ''
    this.street = ''
    this.streetNo = ''
    this.apartment = ''
    this.zip = ''
    this.city = ''
    this.einvoice = ''
  }
}

export { Company }
